import { useTranslation } from '@e-kyc/translations';

interface ProgressBarProps {
  currentStep: 1 | 2 | 3;
}

export default function IdentifyProgressBar(props: ProgressBarProps) {
  const { currentStep } = props;
  const totalSteps = 3;
  const progressPercentage = (currentStep / totalSteps) * 100;
  const { t } = useTranslation();

  let progressTitle = '';

  switch (currentStep) {
    case 1:
      progressTitle = 'step.1';
      break;
    case 2:
      progressTitle = 'step.2';
      break;
    case 3:
      progressTitle = 'step.3';
      break;
    default:
      progressTitle = 'Unknown Step';
      break;
  }

  return (
    <div className='sticky top-0 z-10 flex w-full flex-col items-start gap-3 bg-white p-4'>
      <div className='flex w-full items-center gap-2'>
        <h5>
          {currentStep} / {totalSteps}
        </h5>
        <h5>{t(progressTitle)}</h5>
      </div>
      <div className='w-full overflow-hidden rounded-lg bg-gray-200'>
        <div
          className='bg-primary-500 h-2 rounded-lg transition-all duration-300'
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
    </div>
  );
}
